import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./ComboPackageItem.css";
const ComboPackageItem = ({ item }) => {
  const history = useHistory();

  const clickViewDetails = useCallback(
    (id) => {
      history.push(`/package/${id}`);
    },
    [item]
  );

  return (
    <div className="combo-item">
      <div className="combo-item-banner-part">
        <img
          src={item.combo_banner}
          alt="combo-banner"
          style={{ width: "16.9375rem" }}
        />
        <div className="combo-pkg-tag-and-name">
          {item.tag && (
            <div
              className="combo-pkg-tag"
              style={{ background: item.tag_color }}
            >
              {item.tag}
            </div>
          )}
          <div className="combo-pkg-name">{item.package_name}</div>
        </div>
      </div>
      <div className="combo-item-data-part">
        <div className="just-at-text">Just at</div>
        <div className="combo-item-price">
          ₹{item.discount_amount}
          <span
            className="combo-home-original-amnt"
            style={{ textDecoration: "line-through" }}
          >
            {item.amount == item.discount_amount ? "" : item.amount}
          </span>
          <div
            style={{
              fontSize: "16px",
              backgroundColor: "#D1F7DC",
              color: "#117A44",
              width: "fit-content",
              padding: "0px 5px",
              borderRadius: "3px",
            }}
          >
            {item.offer_discount_amount}
          </div>
        </div>
        <div
          className="combo-home-view-button"
          onClick={() => clickViewDetails(item.package_id)}
        >
          View Details
        </div>
      </div>
    </div>
  );
};

export default ComboPackageItem;
